import BrandFreeAreaService from '@/services/free-area/brand-free-area'

export default class SearchContactLens2FreeAreaService extends BrandFreeAreaService {
  protected get freeAreaPaths() {
    return [
      'SearchContactLens2',
    ]
  }
}
